import React, { useEffect, useState } from "react";
import BackIcon from "../../comman/action/BackIcon";
import { useNavigate, useParams } from "react-router-dom";
import { Input, TextArea } from "../../components/Form";
import CancelIcon from "@mui/icons-material/Cancel";
import PostAddIcon from "@mui/icons-material/PostAdd";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";
import {
  fathSubscriptionApi,
  updatePlanApi,
} from "../../services/subscription";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useButtonLoader from "../../hooks/UseButtonLoader";

const UpdateSubscription = () => {
  const { plan } = useParams();
  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [buttonref, buttonLoader] = useButtonLoader("Update");

  const [input, setInput] = useState({
    title: "",
    duration: "",
    price: "",
    discountPrice: "",
    productId: "",
    description:""
  });
  const [error, setError] = useState({});
  const [benefit, setBenefit] = useState([{ id: 1, benefits: "" }]);

  //----------Add-more-Benefits--------------
  // const addBenefit = () => {
  //     setBenefit([...benefit, { id: Date.now(), benefits: '' }]);
  // };
  const addBenefit = () => {
    const newRow = {
      id: Date.now(),
      benefits: "",
    };
    setBenefit([...benefit, newRow]);
  };
  //----------remove-benefits---------------
  const removeRow = (id) => {
    const updateRow = benefit.filter((data) => data.id !== id);
    setBenefit(updateRow);
  };
  //------------onChange-benefit-------------------
  const handleBenefits = (e, id) => {
    const { name, value } = e.target;
    const data = benefit.map((data) => {
      if (data.id === id) {
        return { ...data, [name]: value };
      }
      return data;
    });
    setBenefit(data);
  };
  //------------validation-----------------
  const validation = () => {
    let status = true;
    let errorMessage = {};

    if (!input?.title) {
      errorMessage["title"] = "please enter title";
      status = false;
    }
    if (!input?.productId) {
      errorMessage["productId"] = "please enter productId";
      status = false;
    }
    if (!input?.duration) {
      errorMessage["duration"] = "please enter duration";
      status = false;
    }
    if (!input?.price) {
      errorMessage["price"] = "please enter price";
      status = false;
    }
    if (!input?.discountPrice) {
      errorMessage["discountPrice"] = "please enter discountPrice";
      status = false;
    }
    if (!input?.description) {
      errorMessage["description"] = "please enter description";
      status = false;
    }
    // benefit.forEach((data) => {
    //   if (!data?.benefits) {
    //     errorMessage["benefits"] = "please enter benefits";
    //     status = false;
    //   }
    // });

    setError(errorMessage);
    return status;
  };
  const Submit = () => {
    if (validation()) {
      alert("done Validation");
    }
  };
  //------------get-subscription-value----------------
  useEffect(() => {
    const fathSubscription = async () => {
      try {
        showLoader();
        const res = await fathSubscriptionApi({ type: plan });
        if (res?.data?.status === 200) {
          const data = res?.data?.data?.plan;
          setInput(data || {});
          // const benefitValue =
          //   data?.benifits.map((benefit, index) => ({
          //     id: Date.now() + index,
          //     benefits: benefit,
          //   })) || [];
          // setBenefit(benefitValue);
          hideLoader();
        } else {
          elseMessage(res);
          hideLoader();
        }
      } catch (err) {
        catchMessage(err);
        hideLoader();
      }
    };
    fathSubscription();
  }, [plan]);
  //-------------update-subscription----------------------
  const updatePlan = async () => {
    const status = validation();
    if (status) {
      const data = benefit.map((data) => data?.benefits);
      const finalDate = { ...input, type: plan, benifits: data };
      try {
        buttonLoader(true);
        const res = await updatePlanApi(finalDate);
        if (res?.data?.status === 200) {
          successMessage(res);
          navigate(-1);
          buttonLoader(false);
        } else {
          elseMessage(res);
          buttonLoader(false);
        }
      } catch (err) {
        catchMessage(err);
        buttonLoader(false);
      }
    }
  };
  //-----------onChange-input-handler-------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };
  return (
    <div className="WrapperArea">
      {loader}
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">
            <BackIcon />
            Update Subscription
          </h4>
        </div>

        <div className="row">
          <div className="col-6 mb-2 ">
            <Input
              type="text"
              label="Title"
              className="form-control"
              name="title"
              placeholder="Enter title"
              value={input?.title || ""}
              onChange={handleChange}
              error={error?.title}
              maxLength={50}
            />
          </div>
          <div className="col-6 mb-2 ">
            <Input
              type="text"
              label="Product Id"
              className="form-control"
              name="productId"
              placeholder="Enter ProductId"
              value={input?.productId || ""}
              onChange={handleChange}
              error={error?.productId}
              //   maxLength={50}
            />
          </div>
          <div className="col-6 mb-2">
            <Input
              type="number"
              label="Duration"
              className="form-control"
              name="duration"
              placeholder="Enter duration"
              value={input?.duration || ""}
              onChange={handleChange}
              error={error?.duration}
              maxLength={7}
            />
          </div>
          <div className="col-6 mb-2">
            <Input
              type="text"
              label="Price"
              className="form-control"
              name="price"
              placeholder="Enter price"
              value={input?.price || ""}
              onChange={handleChange}
              error={error?.price}
              maxLength={7}
            />
          </div>
          <div className="col-6 mb-2">
            <Input
              type="text"
              label="Discount Price"
              className="form-control"
              name="discountPrice"
              placeholder="Enter discountPrice"
              value={input?.discountPrice || ""}
              onChange={handleChange}
              error={error?.discountPrice}
              maxLength={7}
            />
          </div>
          <div className="col-6 mb-2">
            <Input
              type="text"
              label="Description"
              className="form-control"
              name="description"
              placeholder="Enter description"
              value={input?.description || ""}
              onChange={handleChange}
              error={error?.description}
              // maxLength={7}
            />
          </div>
          {/* <div className="col-6 mb-2">
            <button onClick={addBenefit} className="aadIcon">
              <PostAddIcon />
              Add More
            </button>
          </div>

          <div className="row ">
            {benefit.length > 0 &&
              benefit.map((data, index) => {
                return (
                  <div className="col-6 position-relative" key={index}>
                    <TextArea
                      label="Benefits"
                      className="form-control textAreaError"
                      name="benefits"
                      placeholder="Enter Benefits"
                      value={data?.benefits}
                      onChange={(e) => handleBenefits(e, data.id)}
                      error={error?.benefits}
                      maxLength={300}
                    />
                    {index > 0 && (
                      <div
                        className="closeIcon"
                        onClick={() => removeRow(data?.id)}
                      >
                        <CancelIcon />
                      </div>
                    )}
                  </div>
                );
              })}
          </div> */}
        </div>

        <button className="btn_size mt-3" ref={buttonref} onClick={updatePlan}>
          Update
        </button>
      </div>
    </div>
  );
};

export default UpdateSubscription;
